import { call, takeEvery } from 'redux-saga/effects';
import { captureException } from '@sentry/nextjs';
import ActionTypes from '../../../../Data/ActionTypes';
import JourneyOutcome from '../../../../Data/JourneyOutcome';
import JourneyOutcomeDetail from '../../../../Data/JourneyOutcomeDetail';
import { incrementMetric } from '../../../../Services/Datadog';
import { getErrorTypeTag } from '../clientApiError.helpers';
import reportJourneyOutcomeOnce from '../reportJourneyOutcomeOnce';

export function* refuseClientApiJourneyWorker() {
  try {
    yield call(reportJourneyOutcomeOnce, {
      outcome: JourneyOutcome.GOAL_UNMET,
      outcomeDetail: JourneyOutcomeDetail.SKIPPED_BOOKING_JOURNEY,
    });
  } catch (error) {
    incrementMetric({
      name: 'refuseClientApiJourneyError',
      tags: { type: getErrorTypeTag(error) },
    });
    captureException(error);
  }
}

export default function* refuseClientApiJourneyWatcher() {
  yield takeEvery(
    ActionTypes.REFUSE_CLIENT_API_JOURNEY,
    refuseClientApiJourneyWorker
  );
}
